import { render, staticRenderFns } from "./AddHorseTemperature.vue?vue&type=template&id=5ea7ae91&"
import script from "./AddHorseTemperature.vue?vue&type=script&lang=js&"
export * from "./AddHorseTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports